import { ITelegramAccountRepository } from '../../ports/ITelegramAccountRepository';
import { TelegramAccountEntity } from '../../../domain/entities/TelegramAccount';

export class GetTelegramAccountUseCase {
  constructor(private repo: ITelegramAccountRepository) {}
  async execute(uuid: string): Promise<TelegramAccountEntity | null> { return this.repo.get(uuid); }
}
